import { localize } from '../i18n';
import DialogTitle from './ui/FitDialogTitle';
import Button from './ui/FitButton';
import React from 'react';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import StableDialog from './StableDialog';
import { ANDROID_STORE_URL, IOS_STORE_URL } from '../utils/storeLinks';
import WebviewMessenger from '../utils/WebviewMessenger';

export default function FeatureUpdateDialog({ open, onClose, platform }) {
    return <StableDialog open={open} onClose={onClose} aria-labelledby="feature-update-title"
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 340, mx: 3 } }}>
        <DialogTitle id="feature-update-title" sx={{ fontSize: '1.15rem', fontWeight: 700, color: '#1a1a1a', px: 2.5, pt: 2.5, pb: 1 }}>{localize("업데이트가 필요해요")}</DialogTitle>
        <DialogContent sx={{ px: 2.5, pb: 0 }}>
            <DialogContentText sx={{ fontSize: '1rem', color: '#666', lineHeight: 1.55, wordBreak: 'keep-all' }}>{localize("새 기능을 사용하려면")}<br />{localize("앱을 업데이트해주세요.")}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', px: 2.5, pt: 2.5, pb: 2.5, gap: 1, '& > :not(style) ~ :not(style)': { ml: 0 } }}>
            <Button onClick={onClose} variant="text"
                sx={{ flex: 1, minHeight: 44, py: 1.1, borderRadius: 2, fontSize: '1rem', fontWeight: 600,
                    color: '#666', bgcolor: '#f5f5f5', '&:hover': { bgcolor: '#ececec' } }}>{localize("나중에")}</Button>
            <Button variant="contained" disableElevation disabled={!platform || !['android', 'ios'].includes(platform)}
                sx={{ flex: 1, minHeight: 44, py: 1.1, borderRadius: 2, fontSize: '1rem', fontWeight: 700,
                    color: '#5a4a00', bgcolor: '#ffe566', '&:hover': { bgcolor: '#e8d040' } }}
                onClick={() => WebviewMessenger.openExternalUrl(
                    platform === 'ios' ? 'itms-apps://itunes.apple.com/app/id6760472186' : 'market://details?id=com.kkomok.pillreminder',
                    platform === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL,
                )}>{localize("업데이트")}</Button>
        </DialogActions>
    </StableDialog>;
}
